import React from 'react';

export const centeredStyle = (
  width: number,
  height?: number,
): React.CSSProperties => ({
  position: 'absolute',
  top: `calc(50% - ${width / 2}px)`,
  left: `calc(50% - ${(height ?? width) / 2}px)`,
});

export const centeredCircularProgressStyle = centeredStyle(40);

export const whiteCircularProgressStyle: React.CSSProperties = {
  color: 'white',
};
